// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"c06076ca","496":"044144ab","939":"cdaa81ab","984":"f4fcf03b"}[chunkId] + ".chunk.js";
};